module.exports = __webpack_public_path__ + "static/media/technology.f16e768c.jpg";